module.exports = __webpack_public_path__ + "img/djxh.6024347c.png";